var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleasemanagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14093_20382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.586 13L21 10.414V6H23V9.586L25 11.586L23.586 13Z",
    fill: "#2679FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18C20.4178 18 18.871 17.5308 17.5554 16.6518C16.2398 15.7727 15.2145 14.5233 14.609 13.0615C14.0035 11.5997 13.845 9.99113 14.1537 8.43928C14.4624 6.88743 15.2243 5.46197 16.3431 4.34315C17.462 3.22433 18.8874 2.4624 20.4393 2.15372C21.9911 1.84504 23.5997 2.00347 25.0615 2.60897C26.5233 3.21447 27.7727 4.23985 28.6518 5.55544C29.5308 6.87103 30 8.41775 30 10C29.9976 12.121 29.1539 14.1544 27.6542 15.6542C26.1544 17.1539 24.121 17.9976 22 18ZM22 4C20.8133 4 19.6533 4.3519 18.6666 5.01119C17.6799 5.67047 16.9109 6.60755 16.4567 7.7039C16.0026 8.80026 15.8838 10.0067 16.1153 11.1705C16.3468 12.3344 16.9182 13.4035 17.7574 14.2426C18.5965 15.0818 19.6656 15.6532 20.8295 15.8847C21.9933 16.1162 23.1997 15.9974 24.2961 15.5433C25.3925 15.0892 26.3295 14.3201 26.9888 13.3334C27.6481 12.3467 28 11.1867 28 10C27.9983 8.40924 27.3656 6.88413 26.2407 5.75929C25.1159 4.63445 23.5908 4.00175 22 4Z",
    fill: "#2679FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63 18L15.63 24H30V22H16.37L9.37 16H4V2H2V28C2.00066 28.5302 2.21159 29.0386 2.58652 29.4135C2.96145 29.7884 3.46977 29.9993 4 30H30V28H4V18H8.63Z",
    fill: "#2679FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14093_20382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleasemanagement);
export default __webpack_public_path__ + "static/media/Release management.de36dda3fc80ed404628e7641ed92913.svg";
export { ForwardRef as ReactComponent };